import React from "react";
import { useParams, Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

const TITLES = {
  employees: "Employees",
  time: "Time & Attendance",
  care: "Care Documentation",
  scheduling: "Scheduling",
  clients: "Clients",
  compliance: "HR & Compliance",
  payroll: "Payroll",
  reports: "Reports",
};

export default function ComingSoon() {
  const { module } = useParams();
  const title = TITLES[module] || "This Module";

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-20 text-center">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-secondary text-muted-foreground mb-5" data-testid="coming-soon-badge">
        <Sparkles className="w-3.5 h-3.5" />
        Coming Soon
      </div>
      <h1 className="heading-display mb-3">{title}</h1>
      <p className="text-muted-foreground max-w-md mx-auto">
        This module is part of the Leynix platform roadmap. We&apos;re building it now —
        you&apos;ll be notified when it&apos;s ready to launch.
      </p>
      <Link to="/dashboard" className="btn-secondary mt-8 inline-flex" data-testid="coming-soon-back">
        <ArrowLeft className="w-4 h-4" /> Back to Dashboard
      </Link>
    </div>
  );
}
